import { BenefitsContent } from "@/common/lib/types";
import { cn } from "@/lib/tailwind";
import { getCloudinaryURL } from "@/utils/cloudinary";
// import Image from "next/image";
import Image from "@/components/ui/imageV2/ImageV2";
import NoImageSrc from "@/assets/images/no_image.svg";

interface IProps {
  className?: string;
  benefitsData: BenefitsContent;
}

const BenefitSection = ({ benefitsData, className }: IProps) => {
  return (
    <section
      className={cn("flex flex-col items-center justify-center px-5 md:container", className)}
    >
      <h3 className="text-base font-bold">{benefitsData?.title}</h3>
      <div className="flex gap-[5px] pt-7 md:gap-[100px] md:py-10">
        {benefitsData?.items?.map((benefit, idx) => (
          <div key={idx} className="flex flex-1 flex-col items-center justify-start gap-[10px]">
            {benefit?.media ? (
              <Image
                className="h-16 w-16"
                width={64}
                height={64}
                src={getCloudinaryURL(benefit?.media) ?? NoImageSrc}
                alt={benefit?.title}
              />
            ) : (
              <></>
            )}
            <h3 className="text-center text-sm leading-[18px] text-tertiary-6">{benefit?.title}</h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BenefitSection;
